// src/components/Image/Image.jsx
import React from 'react';
import './Image.css';
import Typewriter from 'typewriter-effect';
import { useNavigate } from 'react-router-dom';
import { useModal } from '../../contexts/ModalContext';

const defaultProps = {
  image: 'https://images.unsplash.com/photo-1543783207-ec64e4d95325?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3wyMDUzMDJ8MHwxfHNlYXJjaHwxfHxlZGlmaWNpb3MlMjB8ZW58MXx8fHwxNzIyNDQwODQ3fDA&ixlib=rb-4.0.3&q=80&w=1080',
};

const Image = (props) => {
  const navigate = useNavigate();
  const { isModalOpen } = useModal();

  const handleButtonClick = () => {
    navigate('/opportunities');
  };

  return (
    <div className={`image-container ${isModalOpen ? 'modal-open' : ''}`} style={{ backgroundImage: `url(${props.image ?? defaultProps.image})` }}>
      <div className="overlay">
        <div className="text-container">
          <h1>
            Transforma tu Futuro con{' '}
            <span className="typewriter-text">
              <Typewriter
                options={{
                  strings: [
                    '<span class="highlight">Inversiones Inmobiliarias</span>',
                    '<span class="highlight">Portafolios Diversificados</span>',
                    '<span class="highlight">Oportunidades Únicas</span>',
                  ],
                  autoStart: true,
                  loop: true,
                  delay: 75,
                  deleteSpeed: 50,
                }}
              />
            </span>
          </h1>
          <button onClick={handleButtonClick}>Descubre Nuestras Oportunidades</button>
        </div>
      </div>
    </div>
  );
};

export default Image;
